import React from 'react';
import PropTypes from 'prop-types';
import FrameworkUtils from 'utils/framework';
import { Link, Grid, Text } from 'components/ui';
import InfoButton from 'components/InfoButton/InfoButton';
import { globalModals, renderModal } from 'utils/globalModals';

const { RETAIL_DELIVERY_FEE_INFO } = globalModals;

const { wrapFunctionalComponent } = FrameworkUtils;

function RetailDeliveryFeeItem({ defaultText, qty, visible = false, globalModals: globalModalsData } = {}) {
    const modalData = globalModalsData?.[RETAIL_DELIVERY_FEE_INFO];
    const infoText = modalData?.buttonText || 'More information';
    const showModal = () => {
        renderModal(modalData);
    };

    return visible ? (
        <Grid
            gap={2}
            columns='1fr auto'
            role='row'
        >
            <Link
                padding={1}
                margin={-1}
                data-at={Sephora.debug.dataAt('retail_delivery_fee_label')}
                onClick={showModal}
                role='cell'
                aria-label={`${defaultText}: ${qty}. ${infoText}`}
            >
                {defaultText}{' '}
                <InfoButton
                    marginLeft={-1}
                    aria-label={infoText}
                />
            </Link>
            <Text
                data-at={Sephora.debug.dataAt('retail_delivery_fee')}
                role='cell'
            >
                {qty}
            </Text>
        </Grid>
    ) : null;
}

RetailDeliveryFeeItem.propTypes = {
    defaultText: PropTypes.string.isRequired,
    qty: PropTypes.string.isRequired,
    visible: PropTypes.bool
};

export default wrapFunctionalComponent(RetailDeliveryFeeItem, 'RetailDeliveryFeeItem');
